import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

export function useUserApi() {
    const callApi = useApiCall()

    const ssoInitiate = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.SSO_INITIATE, data, onSuccess, onError)
    }

    const login = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.LOGIN, data, onSuccess, onError)
    }

    const logout = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.LOGOUT, data, onSuccess, onError)
    }
    const registerinitiate = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.REGISTERINITIATE, data, onSuccess, onError)
    }

    const register = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.REGISTER, data, onSuccess, onError)
    }
    const forgotPassword = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.FORGET_PASSWORD, data, onSuccess, onError)
    }
    const resetPassword = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.RESET_PASSWORD, data, onSuccess, onError)
    }

    const updateUser = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.UPDATE_USER, data, onSuccess, onError)
    }
    const ssoverify = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.SSO_VERIFY, data, onSuccess, onError)
    }

    const getUpdateRequestedUsers = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.GET_UPDATE_REQUESTED_USERS, data, onSuccess, onError)
    }
    const updateRequestedUserAction = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.UPDATE_REQUESTED_USER_ACTION, data, onSuccess, onError)
    }

    const getBusinessOwnerDetails = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.GET_BUSINESS_OWNER_DETAILS, data, onSuccess, onError)
    }
    const getTestOpsCopilotToken = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.GET_TESTOPS_COPILOT_TOKEN, data, onSuccess, onError)
    }

    const updateProfile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.UPDATE_PROFILE, data, onSuccess, onError)
    }
    const setLanguage = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.USER.SET_LANGUAGE, data, onSuccess, onError)
    }

    return {
        ssoInitiate,
        login,
        register,
        forgotPassword,
        resetPassword,
        registerinitiate,
        updateUser,
        logout,
        ssoverify,
        getUpdateRequestedUsers,
        updateRequestedUserAction,
        getBusinessOwnerDetails,
        getTestOpsCopilotToken,
        updateProfile,
        setLanguage,
    }
}
